import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { clientIntakeApi } from './api'
import type { ClientIntakeForm } from './types'

export function useClientIntake() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'client-intake'),
    queryFn: clientIntakeApi.get,
    retry: false,
  })
}

export function useSaveClientIntake() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (data: ClientIntakeForm) => clientIntakeApi.save(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'client-intake') }),
  })
}
